module.exports = __webpack_public_path__ + "c01f4b3a686b86ccaf0dacf64a5cf281.jpg";